import { Flex, HStack, TabsContent } from "shared/components/Spor";
import { hideScrollbar } from "shared/utils/hideScrollbar";
import styled from "styled-components";

export const AffectedTrainGrid = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px;
  background: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: 6px;
`;

export const VStackContainer = styled.div`
  container-type: inline-size;
  container-name: VStackContainer;
`;

export const AffectedTrainsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;

export const StyledTabsContents = styled(Flex)`
  overflow: hidden;
  height: 100%;
  ${hideScrollbar}
`;

export const StyledTabsContent = styled(TabsContent)`
  width: 100%;
  height: 100%;
  border-radius: 6px;
`;

export const ButtonGroupFitter = styled(HStack)`
  padding: 12px;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  height: 54px;
`;
